import { api } from 'shared/api'

import { StaticVersionApiSchemas } from './schema'

export const StaticVersionApi = {
  checkVersion: api.base.createGet({
    url: '/sv.txt',
    schemas: StaticVersionApiSchemas.checkVersion,
  }),
}
